import React from 'react';

type SpacerProps = {
    height: string,
}

export const Spacer = (props: SpacerProps) => {

    return (
        <div style={{'height': props.height}}>&nbsp;</div>
    );
}
